<div class="fc-ag-context" [style.top]="topPos" [style.right]="rightPos">
    <ng-template #viewContainer></ng-template>
</div>
<div *ngIf="isShowing"
     class="fc-context-background"
     (click)="removeModal()">
</div>